import React from 'react';

type AdminProps = {
  children: React.ReactNode;
};

export const AdminRestricted: React.FC<AdminProps> = ({ children }) => {
  const storedRole = sessionStorage.getItem('role');
  return storedRole === 'admin' ? <>{children}</> : null;
};